module.exports = __webpack_public_path__ + "static/media/img-ffc0e2f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/chrysalis-logo.png
// module id = 5282
// module chunks = 39